import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { blockRoute } from '@app/store/catalogue/thunks';
import ServiceItem from '@app/components/ServiceItem/ServiceItem';
import classNames from 'classnames';
import './style.scss';
import { SubService as ISubService } from '@app/models/SubService/SubService.interface';
import { SubServiceProps } from './SubServiceProps';
import { MetricParam, useSpatz } from '@app/hooks/useSpatz';

const SubService: React.FC<SubServiceProps> = ({
  service,
  isActive,
  handleClick,
  blockRoute,
}) => {
  const { sendSpatzStats } = useSpatz({
    Services: { catalog: { Главная: {} } },
  });

  const hasOnlineSubService = (
    subServices: ISubService[] | null | undefined
  ) => {
    if (!subServices) {
      return false;
    }
    return (
      subServices.filter(
        (subService) => subService.isElectronic && !subService.isPopularGlobal
      ).length > 0
    );
  };

  const clickHandler = (e: React.SyntheticEvent) => {
    if (!isActive) {
      const data: MetricParam = {
        'клик на родительскую услугу': { click: service.title },
      };
      sendSpatzStats(data);
    }
    blockRoute();
    handleClick(e);
  };

  return (
    <div
      className={classNames('mos-catalog_subservice', {
        'mos-catalog_subservice__open': isActive,
      })}
    >
      <Link
        className="mos-catalog_subservice-title"
        to={isActive ? service.openedRoutePath : service.routePath}
        role="button"
        aria-label={`Услуга ${service.title} с подуслугами`}
        aria-expanded={isActive ? 'true' : 'false'}
        onClick={clickHandler}
      >
        {hasOnlineSubService(service.subServices) && (
          <div className="mos-catalog_subservice-mark">онлайн</div>
        )}
        {service.marks &&
          !service.isPopularGlobal &&
          service.marks.map((mark) => (
            <div
              key={mark.id}
              className={`mos-service-item_label mos-service-item_label-${mark.code}`}
            >
              {mark.title}
            </div>
          ))}
        <div>{service.title}</div>
      </Link>
      <div className="mos-catalog_subservice-list">
        {service.subServices?.map((subservice) => (
          <ServiceItem key={subservice.id} service={subservice} />
        ))}
      </div>
    </div>
  );
};

const dispatchProps = {
  blockRoute,
};

const ConnectedSubService = connect(null, dispatchProps)(SubService);

export default ConnectedSubService;
